/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
/* import loaing from './img/loading1.gif'; */
import classes from './Loading.scss';

const Loading = () => <div className={classes.loading}>{/* <img style={{ userSelect: 'none', margin: 'auto' }} src={loaing} alt="Loading Laa" /> */}</div>;

export default Loading;
